import { SuspiciousLoginPage } from './SuspiciousLoginPage';

export default SuspiciousLoginPage;
//
